module.exports = __webpack_public_path__ + "img/teppiche.73c6566.png";